<template>
  <div class="service-assignment">
    <div class="page-header">
      <h1><i class="bi bi-clipboard-check"></i> Asignación de Servicios</h1>
      <p class="page-description">Gestiona la asignación de listas de picking y almacenamiento a operarios</p>
    </div>

    <!-- Tabs para alternar entre servicios -->
    <div class="service-tabs">
      <button 
        class="tab-button" 
        :class="{ active: activeTab === 'picking' }"
        @click="activeTab = 'picking'"
      >
        <i class="bi bi-box-arrow-up"></i> Listas de Picking
      </button>
      <button 
        class="tab-button" 
        :class="{ active: activeTab === 'storage' }"
        @click="activeTab = 'storage'"
      >
        <i class="bi bi-box-arrow-in-down"></i> Listas de Almacenamiento
      </button>
    </div>

    <!-- Contenido de Picking -->
    <div v-if="activeTab === 'picking'" class="tab-content">
      <PickingAssignment />
    </div>

    <!-- Contenido de Almacenamiento -->
    <div v-if="activeTab === 'storage'" class="tab-content">
      <StorageAssignment />
    </div>
  </div>
</template>

<script>
import PickingAssignment from '@/components/picking/PickingAssignment.vue'
import StorageAssignment from '@/components/storage/StorageAssignment.vue'

export default {
  name: 'ServiceAssignment',
  components: {
    PickingAssignment,
    StorageAssignment
  },
  data() {
    return {
      activeTab: 'picking'
    }
  },
  mounted() {
    // Si hay un parámetro en la URL, cambiar a esa tab
    const tab = this.$route.query.tab
    if (tab && ['picking', 'storage'].includes(tab)) {
      this.activeTab = tab
    }
  },
  watch: {
    activeTab(newTab) {
      // Actualizar URL sin recargar la página
      this.$router.replace({ 
        query: { ...this.$route.query, tab: newTab } 
      })
    }
  }
}
</script>

<style scoped>
.service-assignment {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  color: #2c3e50;
  margin-bottom: 10px;
  font-size: 2rem;
  font-weight: 600;
}

.page-header h1 i {
  margin-right: 10px;
  color: #3498db;
}

.page-description {
  color: #7f8c8d;
  font-size: 1.1rem;
  margin: 0;
}

.service-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #ecf0f1;
}

.tab-button {
  background: none;
  border: none;
  padding: 15px 25px;
  font-size: 1rem;
  font-weight: 500;
  color: #7f8c8d;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-button:hover {
  color: #3498db;
  background-color: #f8f9fa;
}

.tab-button.active {
  color: #3498db;
  border-bottom-color: #3498db;
  background-color: #f8f9fa;
}

.tab-button i {
  font-size: 1.1rem;
}

.tab-content {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .service-assignment {
    padding: 15px;
  }
  
  .page-header h1 {
    font-size: 1.5rem;
  }
  
  .service-tabs {
    flex-direction: column;
  }
  
  .tab-button {
    text-align: left;
    border-bottom: 1px solid #ecf0f1;
    border-right: none;
  }
  
  .tab-button.active {
    border-bottom-color: #ecf0f1;
    border-left: 3px solid #3498db;
  }
}
</style> 